/* @flow */
import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { hoverSelector } from '@braindate/ui/lib/token/selector';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    backgroundColor: 'transparent',
    border: ({
      customColor,
      withSuccess,
      theme,
    }: ThemeFunction<{ customColor?: string, withSuccess: boolean }>) =>
      `solid 1px ${
        withSuccess
          ? theme.successTextColor
          : customColor
          ? customColor
          : theme.accentColor
      }`,
    color: ({
      customColor,
      withSuccess,
      theme,
    }: ThemeFunction<{ customColor?: string, witSuccess: boolean }>) =>
      withSuccess
        ? theme.successTextColor
        : customColor
        ? customColor
        : theme.accentColor,
    fill: ({ customColor, theme }: ThemeFunction) =>
      customColor ? customColor : theme.accentColor,
    stroke: ({ customColor, theme }: ThemeFunction) =>
      customColor ? customColor : theme.accentColor,
    textTransform: 'uppercase',
    fontSize: rem(12, baseFontSize),

    WebkitFontSmoothing: 'antialiased',

    [hoverSelector]: {
      backgroundColor: ({
        customColor,
        withSuccess,
        theme,
      }: ThemeFunction<{ customcolor?: String, withSuccess: boolean }>) =>
        withSuccess
          ? theme.successTextColor
          : customColor
          ? customColor
          : theme.accentColor,
      color: ({ theme }: ThemeFunction) => theme.textColorReverse,
    },

    '&:active': {
      backgroundColor: 'transparent',
    },
  },
  'root-withError': {
    color: ({ theme }: ThemeFunction) => theme.errorMessageColor,
    borderColor: ({ theme }: ThemeFunction) => theme.errorMessageColor,
    '&:hover': {
      backgroundColor: ({ theme }: ThemeFunction) => theme.errorMessageColor,
    },
  },
};
